import Model from '../framework/model.js';
import Utils from '../framework/utils.js';

const defaults = {
  options: {
    all: {
      division: [],
      locationType: []
    },
    displayed: {
      division: [],
      locationType: []
    }
  },
  currentFilter: {
    division: null,
    locationType: null
  },
  selectedFilter: {
    division: null,
    locationType: null
  }
}

class MapFilterModel extends Model {
  constructor(data = {}) {
    data.options.displayed = data.options.all;
    super({data: data, defaults: defaults });
  }

  checkItem(item, filter = null) {
    if (filter == null) filter = this.get('currentFilter');

    return (Utils.isEmpty(filter.division) || item.data.divisions.map((a) => a.id).includes(filter.division.id)) &&
      (Utils.isEmpty(filter.locationType) || item.data.types.map((a) => a.id).includes(filter.locationType.id));
  }

  selectFilter(filter, items = null) {
    if (filter.division)
      filter.division = this.get('options.all.division').find((a) => a.id == filter.division);
    if (filter.locationType)
      filter.locationType = this.get('options.all.locationType').find((a) => a.id == filter.locationType);

    this.set('selectedFilter', filter);

    this.set('options.displayed', {
      division: this.getFilteredFilters(filter, 'division', this.get('options.all.division'), items, (i) => i.data.divisions.map((a) => a.id), (a) => a.id),
      locationType: this.getFilteredFilters(filter, 'locationType', this.get('options.all.locationType'), items, (i) => i.data.types.map((a) => a.id), (a) => a.id)
    })
  }

  getFilteredFilters(selectedFilter, filterName, filterList, items, itemValueFn, filterValueFn) {
    let tempFilter = Utils.deepClone(selectedFilter);
    tempFilter[filterName] = null;
    let ret = filterList.filter((a) => {
      return (items && items.length) ? items.filter((i) => this.checkItem(i, tempFilter)).flatMap(itemValueFn).includes(filterValueFn(a)) : true
    })
    return ret;
  }

  reset() {
    this.selectFilter(Utils.deepClone(defaults.selectedFilter));
    this.set('currentFilter', Utils.deepClone(defaults.currentFilter));
  }
}

export default MapFilterModel;